import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { Template } from "devextreme-react/core/template";
import Modal from "react-modal";
import { DateBox, LoadPanel, RadioGroup, SelectBox } from "devextreme-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { DateFormat } from "../../helpers/fixcodes.js";
import moment from "moment";
import {
  axiosGet,
  axiosPost,
  axiosPutWithParamBody,
} from "../../apis/useAxios.js";
import UserActivityHistoryComponent from "../Shared/UserActivityHistoryComponent.jsx";

const position = { of: "#historydiv" };

const CrewTypeCategoryLst = [
  { id: 1, code: "P", name: "Cockpit" },
  { id: 2, code: "F", name: "Cabin Crew" },
  { id: 0, code: "", name: "Both" },
];

export class CrewTypeTransportConfigurationComponent extends Component {
  static displayName = CrewTypeTransportConfigurationComponent.name;
  constructor(props) {
    super(props);
    this.state = {
      loadPanelVisible: false,
      isSubmitted: false,
      showCrewTypeTransportModal: false,
      viewReadOnly: false,
      airportCode: "",
      transportId: 0,
      wefDate: "",
      airportListDropdown: [],
      transporterListDropdown: [],
      transporterGridDataSource: [],
      crewTypeCategoryDataSource: [],
      crewTypeCategoryCode: "",
      crewTypeConfigData: null,
      historyModal: {
        openModal: false,
        airlineCode: "",
        transportId: "",
        displayTitle: "",
      },
      errors: {
        airportCode: "",
        transport: "",
        crewTypeCategoryCode: "",
        wefDate: "",
      },
    };
  }

  async componentDidMount() {
    this.setState({
      crewTypeCategoryDataSource: CrewTypeCategoryLst,
    });
    await this.getCrewTypeTransportConfiguration();
  }

  getCrewTypeTransportConfiguration = async () => {
    try {
      this.setState({ loadPanelVisible: true });
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      var request = {};
      request.AirlineCode = airlineCode;
      const response = await axiosPost(
        "CrewTypeConfiguration/CrewTypeTransporterList/",
        request,
      );
      this.setState({
        transporterGridDataSource: response?.payload ?? [],
      });
    } catch (err) {
      console.log(
        "Error in " +
          this.displayName +
          ".getCrewTypeTransportConfiguration function",
        err,
      );
    } finally {
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: this.getCrewTypeTransportConfiguration.bind(this),
      },
    });
    e.toolbarOptions.items.unshift({
      location: "before",
      template: "toolbarTemplate",
    });
  };

  toolbarItemRender = () => {
    return (
      <>
        <div className="row">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.handleAddCrewTypeTransportConfiguration}
          >
            <span title="Submit">
              <i className="fas fa-plus"></i> Add Configuration
            </span>
          </button>
        </div>
      </>
    );
  };

  getAirports = async () => {
    this.setState({
      loadPanelVisible: true,
    });
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${airlineCode}`,
      );
      this.setState({
        airportListDropdown: response?.payload ?? [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirports function",
        err,
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  handleAirportChange = async (e) => {
    try {
      let airportCode = e.value ?? "";
      let err = this.state.errors;
      err.airportCode = "";
      this.setState({
        airportCode: airportCode,
        errors: err,
      });
      if (airportCode) {
        await this.getTransporterDropdown(airportCode);
      } else {
        let err = this.state.errors;
        err.transport = "";
        this.setState({
          transporterListDropdown: [],
          transportId: 0,
          errors: err,
        });
      }
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleAirportChange function",
        error,
      );
    }
  };

  getTransporterDropdown = async (airportCode) => {
    try {
      this.setState({
        loadPanelVisible: true,
      });
      const data = await axiosGet("Account/get-transport-dropdown", {
        airportCode: airportCode,
      });
      this.setState((prev) => ({
        ...prev,
        transporterListDropdown: data.payload ?? [],
        loadPanelVisible: false,
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getTransporterDropdown function",
        err,
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  handleTransporterChange = async (e) => {
    try {
      let err = this.state.errors;
      err.transport = "";
      this.setState({
        transportId: e.value ?? 0,
        errors: err,
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleTransporterChange function",
        error,
      );
    }
  };

  handleAddCrewTypeTransportConfiguration = (e) => {
    try {
      this.setState({
        showCrewTypeTransportModal: true,
        crewTypeCategoryCode: "",
        crewTypeConfigData: null,
      });
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleAddCrewTypeTransportConfiguration function",
        error,
      );
    }
  };

  handleOnEditCrewTypeTransportConfiguration = async (e, data) => {
    try {
      if (data != null) {
        this.setState({
          showCrewTypeTransportModal: true,
          crewTypeConfigData: data,
        });
      }
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnEditCrewTypeTransportConfiguration function",
        error,
      );
    }
  };

  handleOnViewReadOnlyCrewTypeTransportConfiguration = async (e, data) => {
    try {
      if (data != null) {
        this.setState({
          showCrewTypeTransportModal: true,
          viewReadOnly: true,
          crewTypeConfigData: data,
        });
      }
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnEditCrewTypeTransportConfiguration function",
        error,
      );
    }
  };

  handleOnAfterOpenCrewTypeTransportModal = async () => {
    try {
      this.setState({ loadPanelVisible: true });
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let configData = this.state.crewTypeConfigData;
      if (configData !== null) {
        this.setState({
          airportCode: configData.airportCode,
          transportId: configData.transporterId,
          wefDate: configData.wefDate,
          crewTypeCategoryCode: configData.crewType,
          crewTypeCategoryDataSource: CrewTypeCategoryLst.filter((f) => f.code),
        });
        await this.getTransporterDropdown(configData.airportCode);
      } else {
        this.setState({
          crewTypeCategoryDataSource: CrewTypeCategoryLst,
        });
      }
      await this.getAirports();
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnAfterOpenCrewTypeTransportModal function",
        error,
      );
    } finally {
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  handleOnCloseCrewTypeTransportModal = () => {
    try {
      let error = this.state.errors;
      error.airportCode = "";
      error.transport = "";
      error.crewTypeCategoryCode = "";
      error.wefDate = "";
      this.setState({
        showCrewTypeTransportModal: false,
        airportListDropdown: [],
        transporterListDropdown: [],
        crewTypeCategoryCode: "",
        airportCode: "",
        transportId: 0,
        wefDate: "",
        crewTypeConfigData: null,
        viewReadOnly: false,
        errors: error,
      });
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnCloseCrewTypeTransportModal function",
        error,
      );
    }
  };

  changeSelectionCrewType = (e) => {
    try {
      debugger;
      let crewTypeData = e.value ?? "";
      this.setState({
        crewTypeCategoryCode: crewTypeData,
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".changeSelectionCrewType function",
        error,
      );
    }
  };

  isFormValid = () => {
    let formIsValid = true;
    try {
      let errors = this.state.errors;
      errors.airportCode = "";
      errors.transport = "";
      errors.crewTypeCategoryCode = "";
      errors.wefDate = "";
      if (!this.state.airportCode) {
        formIsValid = false;
        errors.airportCode = "Please select airport.";
      }
      if (!this.state.wefDate) {
        formIsValid = false;
        errors.wefDate = "Please select wef date.";
      }
      if (this.state.transportId === 0) {
        formIsValid = false;
        errors.transport = "Please select transporter.";
      }
      if (this.state.crewTypeConfigData !== null) {
        if (!this.state.crewTypeCategoryCode) {
          formIsValid = false;
          errors.crewTypeCategoryCode = "Please select crew type.";
        }
      }
      this.setState({ errors: errors });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".isFormValid function",
        err,
      );
      formIsValid = false;
    }
    return formIsValid;
  };

  isConfirm = async (type, title) => {
    let isResult = false;
    let confirmMessage = "";
    if (type === "add") {
      confirmMessage = "Are you sure want to add new crew type configuration?";
    } else if (type === "sync") {
      confirmMessage = "Are you sure want to sync transport details?";
    } else {
      confirmMessage =
        "Are you sure want to update this crew type configuration?";
    }
    await Swal.fire({
      title: title,
      html: "<strong>" + confirmMessage + "</strong>",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText:
        type === "add"
          ? "Add"
          : type === "update"
            ? "Update"
            : type === "sync"
              ? "Sync "
              : title,
    }).then(async (result) => {
      if (result.isConfirmed) {
        isResult = true;
      }
    });
    return isResult;
  };

  handleOnSubmit = async (e) => {
    //e.preventDefault();
    try {
      if (this.isFormValid()) {
        debugger;
        let crewTypeData = [];
        this.setState({ isSubmitted: true });
        if (this.state.crewTypeConfigData !== null) {
          crewTypeData.push(this.state.crewTypeCategoryCode);
        } else {
          if (this.state.crewTypeCategoryCode) {
            crewTypeData = CrewTypeCategoryLst?.filter(
              (f) => f.code === this.state.crewTypeCategoryCode,
            ).map((m) => m.code);
          } else {
            crewTypeData = this.state.crewTypeCategoryDataSource
              ?.filter((f) => f.code !== "")
              .map((m) => m.code);
          }
        }
        let request = {};
        request.AirlineCode = sessionStorage.getItem("session_airlineCode");
        request.AirportCode = this.state.airportCode;
        request.TransporterId = this.state.transportId;
        request.WefDate = this.state.wefDate
          ? moment(this.state.wefDate).format(DateFormat.SqlDateFormat)
          : "";
        request.CrewType = crewTypeData;
        request.UserId = parseInt(sessionStorage.getItem("session_userId"));
        let type =
          this.state.crewTypeConfigData?.rowIndex === 0 ? "add" : "update";
        let title =
          this.state.crewTypeConfigData?.rowIndex === 0 ? "Add" : "Update";
        let isConfirm = await this.isConfirm(type, title);
        if (isConfirm) {
          const response =
            this.state.crewTypeConfigData?.rowIndex === 0
              ? await axiosPost(
                  "CrewTypeConfiguration/AddCrewTypeTransportConfiguration/",
                  request,
                )
              : await axiosPutWithParamBody(
                  `CrewTypeConfiguration/UpdateCrewTypeTransportConfiguration`,
                  { RowIndex: this.state.crewTypeConfigData?.rowIndex },
                  {
                    AirlineCode: sessionStorage.getItem("session_airlineCode"),
                    AirportCode: this.state.airportCode,
                    TransporterId: this.state.transportId,
                    WefDate: this.state.wefDate
                      ? moment(this.state.wefDate).format(
                          DateFormat.SqlDateFormat,
                        )
                      : "",
                    CrewType: crewTypeData,
                    UserId: parseInt(sessionStorage.getItem("session_userId")),
                  },
                );
          if (this.state.crewTypeConfigData?.rowIndex === 0) {
            if (response?.isSuccess) {
              await Swal.fire({
                allowOutsideClick: false,
                icon: response?.isSuccess ? "success" : "error",
                title: response?.isSuccess ? "Success" : "Oops...",
                text:
                  response?.isSuccess === false &&
                  (response?.message === null || response?.message === "")
                    ? "Unable to process the request."
                    : response?.message === null || response?.message === ""
                      ? "Crew Type Transport configuration has been set successfully."
                      : response?.message,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  this.handleOnCloseCrewTypeTransportModal();
                  await this.getCrewTypeTransportConfiguration();
                }
              });
            } else {
              toast.error(
                response?.message === null || response?.message === ""
                  ? "Unable to process the request."
                  : response?.message,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                  style: { width: "310px" },
                  hideProgressBar: false,
                  newestOnTop: false,
                  closeButton: false,
                },
              );
            }
          } else {
            if (response.isSuccess) {
              await Swal.fire({
                allowOutsideClick: false,
                icon: response.isSuccess ? "success" : "error",
                title: response.isSuccess ? "Success" : "Oops...",
                text:
                  response.isSuccess === false &&
                  (response.message === null || response.message === "")
                    ? "Unable to process the request."
                    : response.message === null || response.message === ""
                      ? "Crew Type Transport configuration has been updated successfully."
                      : response.message,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  this.handleOnCloseCrewTypeTransportModal();
                  await this.getCrewTypeTransportConfiguration();
                }
              });
            } else {
              toast.error(
                response.message === null || response.message === ""
                  ? "Unable to process the request."
                  : response.message,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                  style: { width: "310px" },
                  hideProgressBar: false,
                  newestOnTop: false,
                  closeButton: false,
                },
              );
            }
          }
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleOnSubmit function",
        err,
      );
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  render() {
    const renderGridCell = (data) => {
      let editLink = (
        <a
          title="Edit Crew Type transport configuration"
          onClick={(e) => {
            this.handleOnEditCrewTypeTransportConfiguration(e, data.data);
          }}
        >
          <i className="fas fa-edit"></i>
        </a>
      );
      let viewLink = (
        <a
          title="View"
          style={{ paddingLeft: `${editLink ? "6px" : ""}` }}
          onClick={(e) => {
            this.handleOnViewReadOnlyCrewTypeTransportConfiguration(
              e,
              data.data,
            );
          }}
        >
          <i className="fas fa-eye"></i>
        </a>
      );
      let activityHistory = (
        <a
          href="#"
          title="Log"
          onClick={(e) => {
            debugger;
            e.preventDefault();
            this.setState((prev) => ({
              ...prev,
              historyModal: {
                openModal: true,
                airlineCode: data.data.airlineCode,
                transportId: data.data.transporterId,
                displayTitle: data.data.transporterName,
              },
            }));
          }}
          className="btn-link"
        >
          <i
            style={{ cursor: "pointer", marginLeft: "6px" }}
            className="fas fa-exclamation-circle"
          />
        </a>
      );
      return (
        <span style={{ textAlign: "left", width: "auto" }}>
          {editLink}
          {viewLink}
          {activityHistory}
        </span>
      );
    };
    return (
      <>
        <style>{`
          /* ── Crew Type Transport Config — theme matching sidebar #fff0e6 ── */
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
        `}</style>
        <div className="card ca-grid-wrap">
          <div className="card-body">
            <DataGrid
              dataSource={this.state.transporterGridDataSource}
              columnAutoWidth={true}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              rowAlternationEnabled={false}
              //allowColumnResizing={true}
              onCellPrepared={(e) => {
                if (e.rowType === "header") {
                  e.cellElement.style.backgroundColor = "#fff0e6";
                  e.cellElement.style.color = "#000000";
                }
              }}
              onToolbarPreparing={this.onToolbarPreparing}
            >
              <Column
                dataField="rowIndex"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowFiltering={false}
                allowExporting={false}
                width={75}
                //alignment={"left"}
                cellRender={renderGridCell}
              />
              <Column
                dataField="airlineCode"
                caption="Airline"
                allowSorting={false}
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={100}
                alignment={"center"}
              />
              <Column
                dataField="airportCode"
                caption="Airport"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="crewTypeCategory"
                caption="Crew Type Stay For"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="transporterName"
                caption="Transport"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="transporterEmail"
                caption="Email"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="transporterPhoneNo"
                caption="Phone"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="singleTripVehicleType"
                caption="Single Trip Vehicle Type"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="pilotVehicleType"
                caption="Pilot Vehicle Type"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="flightAttendantVehicleType"
                caption="Flight Attendant Vehicle Type"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
              />
              <Column
                dataField="wefDate"
                caption="Wef Date"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
                dataType="datetime"
                format={DateFormat.DateNorthFormat}
              />
              <Column
                dataField="endDate"
                caption="End Date"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
                dataType="datetime"
                format={DateFormat.DateNorthFormat}
              />
              <Column
                dataField="effectedDate"
                caption="Effected Date"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                allowFiltering={true}
                allowSorting={true}
                dataType="datetime"
                format={DateFormat.DateNorthFormat}
              />
              <GroupPanel visible={false} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Grouping autoExpandAll={true} />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="Crew Type Transport Configuration"
              />
              <Template
                name="toolbarTemplate"
                render={this.toolbarItemRender}
              />
            </DataGrid>
          </div>
        </div>

        {/* Add/Edit/ReadOnly Crew Type Transport Configuration */}
        <Modal
          ariaHideApp={false}
          isOpen={this.state.showCrewTypeTransportModal}
          style={{ content: { width: "40%" } }}
          className={"react-modal"}
          onAfterOpen={this.handleOnAfterOpenCrewTypeTransportModal}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <div className="modal-header">
            <h6 className="modal-title">
              Crew Type Transport Configuration
              {this.state.viewReadOnly ? "(View only)" : ""}
            </h6>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleOnCloseCrewTypeTransportModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label>
                    Airport<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={this.state.airportListDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Airport"
                    name="airportCode"
                    value={this.state.airportCode}
                    displayExpr="airportCode"
                    valueExpr="airportCode"
                    onValueChanged={this.handleAirportChange}
                    showClearButton={true}
                    disabled={this.state.viewReadOnly}
                    searchEnabled={true}
                  />
                  {this.state.errors["airportCode"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["airportCode"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label>
                    Transporter<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={this.state.transporterListDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Transporter"
                    name="transporterName"
                    defaultValue={0}
                    value={this.state.transportId}
                    displayExpr="name"
                    valueExpr="id"
                    onValueChanged={this.handleTransporterChange}
                    showClearButton={true}
                    disabled={this.state.viewReadOnly}
                    searchEnabled={true}
                  />
                  {this.state.errors["transport"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["transport"]}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="row pt-2">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label>
                    Wef Date&nbsp;<span className="text-danger">*</span>
                  </label>
                  <DateBox
                    type="date"
                    className="form-control form-control-sm"
                    name="wefDate"
                    placeholder={DateFormat.DateNorthFormat}
                    displayFormat={DateFormat.DateNorthFormat}
                    showAnalogClock={false}
                    useMaskBehavior={false}
                    defaultValue={this.state.wefDate}
                    value={this.state.wefDate}
                    disabled={this.state.viewReadOnly}
                    acceptCustomValue={true}
                    onValueChanged={(date) => {
                      let err = this.state.errors;
                      err.wefDate = "";
                      this.setState({
                        wefDate: date.value,
                        errors: err,
                      });
                    }}
                  />
                  {this.state.errors["wefDate"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["wefDate"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <span style={{ fontSize: "1em", fontWeight: "bold" }}>
                    Transport For
                  </span>
                  <RadioGroup
                    id="radio-group-with-selection"
                    dataSource={this.state.crewTypeCategoryDataSource}
                    layout="horizontal"
                    value={this.state.crewTypeCategoryCode}
                    valueExpr="code"
                    displayExpr="name"
                    disabled={this.state.viewReadOnly}
                    onValueChanged={this.changeSelectionCrewType}
                  />
                  {this.state.errors["crewTypeCategoryCode"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["crewTypeCategoryCode"]}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              hidden={this.state.viewReadOnly}
              onClick={(e) => {
                this.handleOnSubmit(e);
              }}
            >
              <i
                className={`fas fa-${
                  this.state.isSubmitted ? "spinner fa-spin" : "save"
                }`}
              />
              &nbsp;Save Configuration
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              title="Close"
              onClick={this.handleOnCloseCrewTypeTransportModal}
            >
              <i className="fas fa-times" />
              &nbsp;Close
            </button>
          </div>
        </Modal>

        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />

        {this.state.historyModal.openModal && (
          <UserActivityHistoryComponent
            airlineCode={this.state.historyModal.airlineCode}
            displayTitle={this.state.historyModal.displayTitle}
            columnValue1={this.state.historyModal.transportId}
            onClose={() => {
              this.setState((prev) => ({
                ...prev,
                historyModal: {
                  openModal: false,
                  airlineCode: "",
                  displayTitle: "",
                  hotelCode: "",
                },
              }));
            }}
          />
        )}
      </>
    );
  }
}
